export default theme => ({
    cellGrey: {
        backgroundColor:"#424242", color:"white", border:"1px solid", lineHeight:"0.5", padding:"2px",textAlign:"center",
    },
    typoMont:{
        fontFamily: 'Montserrat',
        fontSize:"0.6rem",
        fontWeight:"bold",
    },
    Mont:{
        fontFamily: 'Montserrat',
    },
    actionsContainer:{
        paddingTop:"12px"
    },
    icon:{
        color:"#ff7800 !important", 
    },
    buttonNext:{
        backgroundColor:"#ff7800",
        color:"white"
    }
    
});


// WEBPACK FOOTER //
// ./src/layouts/components/content/Movistar/Header/styles.jsx